<div class="page-filters-section">
    <div class="each-page-filter-section">
        <span class="each-page-filter-label">User Type</span>
        <mat-select class="each-page-filter-input" [(ngModel)]="user_type" (selectionChange)="getPageData()">
            <mat-option [value]="'client'">Client</mat-option>
            <mat-option [value]="'prospect'">Prospect</mat-option>
        </mat-select>
    </div>
</div>
<ng-container *ngIf="page_data_loaded">
    <div class="metrics-container">
        <div class="stat-card">
            <div class="stat-icon blue-bg">
                <svg width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><path d="m22 6-10 7L2 6"/></svg>
            </div>
            <div class="stat-content">
                <div class="stat-label">No Response</div>
                <div class="stat-main">
                    <h2>{{commonService.abbreviateNumber(page_data['summary']['no_response_value'])}}</h2>
                    <p>{{page_data['summary']['no_response_text']}}</p>
                </div>
            </div>
        </div>

        <div class="stat-card">
            <div class="stat-icon green-bg">
                <svg width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4 12v1a3 3 0 0 0 3 3h10m0 0l-3-3m3 3l-3 3m5-11V9a3 3 0 0 0-3-3H6m0 0l3 3m-3-3l3-3"/></svg>
            </div>
            <div class="stat-content">
                <div class="stat-label">Channel Switch</div>
                <div class="stat-main">
                    <h2>{{commonService.abbreviateNumber(page_data['summary']['channel_switched_value'])}}</h2>
                    <p>{{page_data['summary']['channel_switched_text']}}</p>
                </div>
            </div>
        </div>

        <div class="stat-card highlight-card">
            <div class="stat-icon red-bg">
                <svg width="32" height="32" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <div class="stat-content">
                <div class="stat-label">Advisor Action Needed</div>
                <div class="stat-main">
                    <h2>{{commonService.abbreviateNumber(page_data['summary']['advisor_action_value'])}}</h2>
                    <p>{{page_data['summary']['advisor_action_text']}}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="data-card">
        <div class="data-card-header">
            <div class="title-group">
                <span class="badge blue-b">1</span>
                <h3 class="blue-text">No Emails Opened</h3>
                <span class="counter-badge blue-text">{{commonService.abbreviateNumber(page_data['first_table']['table'].length)}}</span>
            </div>
            <span class="view-link" (click)="show_all_first_table_data = !show_all_first_table_data">
                {{ show_all_first_table_data ? 'View Less' : 'View All' }}
            </span>
        </div>
        <div class="data-card-description">
            <p>{{page_data['first_table']['text']}}</p>
        </div>
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th>Action</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Last Email Sent</th>
                        <th>Last Email Subject</th>
                        <th>Next Step</th>
                    </tr>
                </thead>
                <tbody *ngIf="page_data['first_table']['table'].length > 0">
                    <tr *ngFor="let data of page_data['first_table']['table'] | slice: 0 : getLimit(show_all_first_table_data, page_data['first_table']['table'])">
                        <td>
                            <img src="assets/view-tasks.png" (click)="showUserProfile(data)" [matTooltip]="'View Details'" />
                        </td>
                        <td>{{data.name}}</td>
                        <td>{{data.email}}</td>
                        <td>{{data.last_email_sent | date: "dd MMM yyyy"}}</td>
                        <td>{{data.last_email_subject}}</td>
                        <td>
                            <span class="next-step-tag">{{data.next_step}}</span>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="page_data['first_table']['table'].length == 0">
                    <tr>
                        <td colspan="6" class="data-card-zero-state">No Data Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="data-card">
        <div class="data-card-header">
            <div class="title-group">
                <span class="badge green-b">2</span>
                <h3 class="green-text">Channel Switched</h3>
                <span class="counter-badge green-text">{{commonService.abbreviateNumber(page_data['second_table']['table'].length)}}</span>
            </div>
            <span class="view-link" (click)="show_all_second_table_data = !show_all_second_table_data">
                {{ show_all_second_table_data ? 'View Less' : 'View All' }}
            </span>
        </div>
        <div class="data-card-description">
            <p>{{page_data['second_table']['text']}}</p>
        </div>
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th>Action</th>
                        <th>Name</th>
                        <th>Channel Switched Date</th>
                        <th>Current Channel</th>
                        <th>Last Activity on</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody *ngIf="page_data['second_table']['table'].length > 0">
                    <tr *ngFor="let data of page_data['second_table']['table'] | slice: 0 : getLimit(show_all_second_table_data, page_data['second_table']['table'])">
                        <td>
                            <img src="assets/view-tasks.png" (click)="showUserProfile(data)" [matTooltip]="'View Details'" />
                        </td>
                        <td>{{data.name}}</td>
                        <td>{{data.channel_switched_date | date: "dd MMM yyyy"}}</td>
                        <td>
                            <span class="next-step-tag">{{data.channel}}</span>
                        </td>
                        <td>{{data.last_activity_date | date: "dd MMM yyyy"}}</td>
                        <td>
                            <span class="status-pill red-status" *ngIf="data.status == 'No Response'">No Response</span>
                            <span class="status-pill green-status" *ngIf="data.status == 'Responded'">Responded</span>
                            <span class="status-pill orange-status" *ngIf="data.status == 'Awaiting Response'">Awaiting Response</span>
                            <span class="status-pill light-green-status" *ngIf="data.status == 'Engaged'">Engaged</span>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="page_data['second_table']['table'].length == 0">
                    <tr>
                        <td colspan="6" class="data-card-zero-state">No Data Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="data-card">
        <div class="data-card-header">
            <div class="title-group">
                <span class="badge red-b">3</span>
                <h3 class="red-text">Advisor Action Required</h3>
                <span class="counter-badge red-text">{{commonService.abbreviateNumber(page_data['third_table']['table'].length)}}</span>
            </div>
            <span class="view-link" (click)="show_all_third_table_data = !show_all_third_table_data">
                {{ show_all_third_table_data ? 'View Less' : 'View All' }}
            </span>
        </div>
         <div class="data-card-description">
            <p>{{page_data['third_table']['text']}}</p>
        </div>
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th>Action</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>Total Activities</th>
                        <th>Last Activity Date</th>
                        <th>Recommended Action</th>
                    </tr>
                </thead>
                <tbody *ngIf="page_data['third_table']['table'].length > 0">
                    <tr *ngFor="let data of page_data['third_table']['table'] | slice: 0 : getLimit(show_all_third_table_data, page_data['third_table']['table'])">
                        <td>
                            <img src="assets/view-tasks.png" (click)="showUserProfile(data)" [matTooltip]="'View Details'" />
                        </td>
                        <td>{{data.name}}</td>
                        <td>{{data.email}}</td>
                        <td>{{data.telephone_number}}</td>
                        <td>{{data.total_activities}}</td>
                        <td>{{data.last_activity_date | date: "dd MMM yyyy"}}</td>
                        <td>
                            <!-- <button class="recommended-action" *ngIf="data.recommended_actions == 'phone_call'" (click)="addManualTask(data)">
                                <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                                </svg> 
                                <span> Call</span>
                            </button>
                            <button class="recommended-action" *ngIf="data.recommended_actions == 'direct_mail'" (click)="addManualTask(data)">
                                <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                    <path d="m22 6-10 7L2 6"/>
                                </svg>
                                <span> Direct Mail</span>
                            </button> -->

                            <button class="recommended-action" *ngIf="data.recommended_actions == 'phone_call'" (click)="addActivity(data)">
                                <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                                </svg> 
                                <span> Call</span>
                            </button>
                            <button class="recommended-action" *ngIf="data.recommended_actions == 'direct_mail'" (click)="addActivity(data)">
                                <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                    <path d="m22 6-10 7L2 6"/>
                                </svg>
                                <span> Direct Mail</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="page_data['third_table']['table'].length == 0">
                    <tr>
                        <td colspan="6" class="data-card-zero-state">No Data Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!page_data_loaded">
    <app-loader [loading_text]="'Loading AI Governance - Engagement Dashboard'"></app-loader>
</ng-container>

<ng-container *ngIf="show_user_profile">
	<ng-container *ngIf="user_profile_data_type == 'Client'">
		<app-customer-profile [data]="user_profile_data" [client_type]="'Client'" (profileClosed)="profileClosed($event)"></app-customer-profile>
	</ng-container>
	<ng-container *ngIf="user_profile_data_type == 'Lead'">
		<ng-container *ngIf="user_profile_data.source_type_id != 1 ">
			<app-lead-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-lead-profile>
		  </ng-container>
		  <ng-container *ngIf="user_profile_data.source_type_id == 1 ">
			<app-bank-customer-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-bank-customer-profile>
		  </ng-container>
	</ng-container>
</ng-container>

<ng-container *ngIf="show_activity_data">
    <ng-container *ngFor="let activity_data of selected_activities_list; let index = index;">
        <app-activity-template-v2 [data]="activity_data" [activity_user_data]="activity_user_data" [activity_index]="index" [activity_action_type]="'Edit'" [activity_user_data]="activity_user_data" (activityDetailsClosed)="activityDetailsClosed($event)"></app-activity-template-v2>
    </ng-container>
</ng-container>